var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXLogo = function SvgXLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDD5DF",
    d: "M13.969 11.112 22.707.955h-2.07l-7.588 8.819L6.99.954H0l9.164 13.337L0 24.942h2.07l8.013-9.313 6.4 9.313h6.989zm-2.836 3.296-.929-1.328L2.817 2.513h3.18l5.962 8.528.929 1.328 7.75 11.085h-3.181z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "x-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .955h23.472v24H0z"
  })))));
};
export default SvgXLogo;